export var newGuid = function newGuid() {
  return "".concat(Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1), "-").concat(Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1));
};